import { render, staticRenderFns } from "./ReviewCardTooltips.vue?vue&type=template&id=41caa5d5&"
import script from "./ReviewCardTooltips.vue?vue&type=script&lang=js&"
export * from "./ReviewCardTooltips.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCardTooltips.vue?vue&type=style&index=0&id=41caa5d5&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41caa5d5')) {
      api.createRecord('41caa5d5', component.options)
    } else {
      api.reload('41caa5d5', component.options)
    }
    module.hot.accept("./ReviewCardTooltips.vue?vue&type=template&id=41caa5d5&", function () {
      api.rerender('41caa5d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/ReviewCardTooltips/ReviewCardTooltips.vue"
export default component.exports